export default __webpack_public_path__ + "img/f3832eb1208255b65ab2c1eb97b88885.png";